export default __webpack_public_path__ + "files/Roadmap_Mazovia_Region.docx";